import React, { useId } from 'react';
import { useController } from 'react-hook-form';
import SwitchButton from '../../../SwitchButton';
import FormFieldError from '../FormFieldError';

const SwitchField = ({ name, control, rules, label, description, variant = 'default', disabled, ...props }) => {
    const labelId = useId();
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({ name, control, rules });

    return (
        <div className="FormField FormField--switch">
            <div
                className="FormField__switchRow"
                role="group"
                aria-labelledby={label ? labelId : undefined}
            >
                <div className="FormField__switchLabels">
                    {label && <span id={labelId} className="FormField__switchLabel">{label}</span>}
                    {description && <span className="FormField__switchDescription">{description}</span>}
                </div>
                <SwitchButton
                    variant={variant}
                    name={name}
                    checked={!!value}
                    disabled={disabled}
                    changeFn={(val) => onChange(val !== '')}
                    {...props}
                />
            </div>
            <FormFieldError error={error} />
        </div>
    );
};

export default SwitchField;
